import { MachineType } from "operations/schema/schema";

export const filterMachineList = (
  machines: MachineType[],
  filter: string,
  splice: number = 300,
) => {
  const searchTerms = filter.toLocaleLowerCase().split(" ");

  return machines
    .filter((machine: MachineType) => {
      const machineNo = machine.machineNo?.toLocaleLowerCase();
      const modelDescription = machine.modelDescription?.toLocaleLowerCase();
      const location = machine.location?.toLocaleLowerCase();
      return (
        0 <=
        searchTerms.reduce(
          (sum, term) =>
            //min-max search hit pattern filter
            Math.min(
              sum,
              Math.max(
                location?.indexOf(term) ?? -1,
                modelDescription?.indexOf(term) ?? -1,
                machineNo?.indexOf(term) ?? -1,
              ),
            ),
          0, //start with lowest inclusive value
        )
      );
    })
    .slice(0, splice); // limit to render 300 options at once
};
